import { Navbar } from "../components/Navbar";
import { Hero } from "../components/Hero";
import { BrandMark } from "../components/BrandMark";
import { ScriptureMarquee } from "../components/ScriptureMarquee";
import { Manifesto } from "../components/Manifesto";
import { Services } from "../components/Services";
import { Portfolio } from "../components/Portfolio";
import { VerseOfDay } from "../components/VerseOfDay";
import { ApplySection } from "../components/ApplySection";
import { DonateSection } from "../components/DonateSection";
import { AboutLuke } from "../components/AboutLuke";
import { Footer } from "../components/Footer";
import { ChatWidget } from "../components/ChatWidget";

export default function Home() {
  return (
    <div className="bg-white min-h-screen">
      <Navbar />
      <Hero />
      <BrandMark />
      <ScriptureMarquee />
      <Manifesto />
      <Services />
      <Portfolio />
      <VerseOfDay />
      <ApplySection />
      <DonateSection />
      <AboutLuke />
      <Footer />
      <ChatWidget />
    </div>
  );
}
